var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMartiniGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.962 279.625L501.962 57.625C523.212 36.375 508.212 0 478.212 0H33.712C3.712 0 -11.288 36.375 9.962 57.625L128.001 175.664V176H128.337L231.962 279.625V463L220.762 464H152.001C138.751 464 128.001 474.75 128.001 488S138.751 512 152.001 512H360.001C373.251 512 384.001 501.25 384.001 488S373.251 464 360.001 464H281.907C280.206 463.779 278.704 463 276.942 463H279.962V279.625ZM443.712 48L363.712 128H148.212L68.212 48H443.712ZM255.962 235.75L196.212 176H315.712L255.962 235.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMartiniGlass);
export default __webpack_public_path__ + "static/media/martini-glass.81177c4d14221637a31dd4ee7d039bbb.svg";
export { ForwardRef as ReactComponent };